module.exports = {
  "title": "my reports",
  "sub_text": "Inside scoop on your content",
  "cards": {
    "assets": "# of \n Assets",
    "team_members": "Team members",
    "active_users": "Active \n users",
    "asset_views": "# of \n Asset views \n(team)",
    "conversations": "# of \n Conversations",
    "engaged_users": "Engaged \n users",
    "leads": "# of \n Leads",
    "deals": "# of \n Deals",
    "sales": "Value of \n Sales"
  },
  "filters": {
    "no_options": "No options",
    "date": {
      "today": "Today",
      "yesterday": "Yesterday",
      "week_to_date": "Week to Date",
      "month_to_date": "Month to Date",
      "day": "Day",
      "days": "Days",
      "week": "Week",
      "month": "Month",
      "start_date": "Start date",
      "end_date": "End date"
    },
    "entity": {
      "any_entity": "Any Entity",
      "user": "User",
      "user_group": "User Group",
      "contact": "Contact",
      "company": "Company",
      "sub_filter": {
        "is": "is",
        "is_not": "is Not",
        "is_internal": "is Internal",
        "is_not_internal": "is Not Internal",
        "has_role": "Has Role",
      }
    }
  },
  "actions": {
    "apply": "Apply"
  },
  "tabs": {
    "commons": {
      "added": "Added",
      "author": "Author",
      "views": "Views",
      "avg_time": "Avg Time",
      "unique_users": "# of Unique Users",
      "shares": "Shares",
      "downloads": "Downloads",
      "no_data": "No data for the given filters",
      "account_view": "Account View",
      "interactions": "Interactions",
      "deals": "Deals",
      "leads": "Leads",
      "assets": "Assets",
      "asset": "Asset",
      "view": "View",
      "share": "Share",
      "created": "Created",
      "created_by": "Created By",
      "section": "Section",
      "reshares": "reshares",
      "users": "Users",
      "searches" : "Searches",
      "open_rate": "Open Rate",
      "click_rate": "Click Rate",
      "time_spent": "Time Spent",
      "shared_by": "Shared By",
      "recipients": "Recipients",
      "last_active": "Last active",
      "joined": "Joined",
      "role": "Role",
      "headers": {
        "views": "Views",
        "avg_time": "Avg View Time",
        "shares": " Shares",
        "author": "Author",
        "downloads": "Downloads",
        "created_by": "Created By",
        "created_on": "Created On",
        "open_rate": "Open Rate",
        "click_rate": "Click Rate",
        "time_spent": "Time Spent",
        "last_updated": "Last Updated",
        "searches" : "Searches",
        "date_added": "Date Added",
        "account": "Account",
        "content_used": "Content Used",
        "deal_title": "Deal Title",
        "value": "Value",
        "status": "Status",
        "interactions": "Interactions",
        "leads": "Leads",
        "deals": "Deals",
        "last_active": "Last active",
        "asset_name": "Asset Name",
        "created_date": "Created Date",
        "user_name": "User Name",
        "joined_date": "Joined Date",
        "role": "Role",
        "assets": "Assets",
        "name": "Name",
        "email": "Email",
        "recipients": "Recipients",
        "users": "Users",
        "group_name": "Group Name",
        "query": "Query",
        "search_count": "Search Count",
        "asset_count": "Asset Count",
        "contact_name":"Contact Name",
        "company": "Company",
        "reshares": "Reshares",
        "account_name": "Account Name",
        "contacts": "Contacts",
        "campaign_name": "Campaign Name",
        "campaign_source": "Campaign Source",
        "shared_by": "Shared By",
        "shared_on": "Shared On",
        "shared_via": "Shared Via",
        "total_interactions": "Total Interactions",
        "total_leads": "Total Leads",
        "total_deals_closed": "Total Deals Closed",
        "deal": "Deal",
        "deal_value": "Deal Value",
        "deal_stage": "Deal Stage",
        "file_type": "File Type",

        "counts":{
          "shares": "# of shares",
          "downloads": "# of downloads",
          "reshares": "# of Reshares",
          "assets": "# of Assets",
          "searches": "# of Searches",
          "unique_users": "# of Unique Users",
          "recipients": "# of recipients"
        }
      },
      "tool_tips": {
        "avg_time": "Avg. time (mm:ss)",
        "date": "Date",
        "unique_viewers": "Unique viewers",
        "shares": "Shares",
        "asset_views": "Asset Views",
        "performance": {
          "interactions": "Total Interactions",
          "leads": "Total Leads",
          "closed_deals": "Total Closed Deals",
          "closed_deal_value": "Total Closed Deal Value",
          "deals": "Total Deals",
          "deal_value": "Total Deal Value"
        }
      },
      "card": {
        "views": "Views",
        "avg_time": "Avg Time",
        "downloads": "Downloads",
        "author": "Author",
        "reshares": "reshares",
        "users": "Users",
        "open_rate": "Open Rate",
        "click_rate": "Click Rate",
        "time_spent": "Time Spent",
        "shared_by": "Shared By",
        "share": "Share",
        "shares": " Shares",
        "created_by": "Created By",
        "added": "Added",
        "created": "Created",
        "recipients": "Recipients",
        "last_active": "Last active",
        "searches" : "Searches",
        "role": "Role"
      },
      "load_more": {
        "load_more": "Load More",
        "loading": "Loading more items"
      },
      "actions": {
        "view_more": "View more",
        "view_details": "View details"
      }
    },
    "discovery": {
      "title": "Discovery",
      "sub_text": "How does your team discover content?",
      "asset_views": "# of Asset Views",
      "content_discovery": {
        "title": "Content Discovery Matrix",
        "low": "Low discovery",
        "below_average": "Below Average discovery",
        "average": "Average discovery",
        "high_discovery": "High discovery"
      },
      "assets": "# of Assets",
      "collection_activity": "Collection Activity",
      "conversation_activity": "Conversation Activity",
      "popular_with_team": "What's popular with your team?",
      "top_users": "Who are your top users?",
      "top_shares": "Who are your top sharers?",
      "top_user_groups": "Who are your top user groups?",
      "collection_created": "Collections Created",
      "collection_shared": "Collections Shared",
      "frequently_shared_assets": "Frequently Shared Assets",
      "most_searched_query": "What are the most searched queries?",
      "most_used_query": "What are the most used tags?",
      "tooltip_texts":{
        "asset_views": "Monitor daily internal asset views to assess engagement levels",
        "content_discovery_matrix": "Categorize assets by the number of unique platform users who have viewed them. A higher the count of unique viewers, indicate greater content discovery, while a low count of viewers indicate lower discovery",
        "assets": "Track the number of unique assets added to streams each day",
        "collection_activity": "Count of unique collections that were updated on each day including creation and edit activities",
        "conversation_activity": "View the count of shares made, offering insights into content distribution trends",
        "popular_with_team": "Assets ranked by top-views internally along with their engagement metrics",
        "top_users": "Top users ranked based on asset views along with their engagement metrics",
        "top_sharers": "Top sharers ranked based on their sharing activity",
        "top_user_groups": "User groups with the highest cumulative asset views, including share count, view count, and average view time",
        "collection_created": "All collections created with details on the creator, asset count, shares, and views sorted by recency",
        "collection_shared": "All collections shared with details on the creator, asset count, shares, and views sorted by most shared collections",
        "frequently_shared_assets": "Most shared assets with insights into view count, average view time, and share count",
        "most_searched_query": "Discover the most frequently searched queries by users to understand discovery trends",
        "most_used_tags": "Popular tags most frequently used to categorize assets and retrieve them during search",
        "content_discovery":{
          "low_discovery" : "Assets with a low number of unique viewers",
          "below_average_discovery" : "Assets viewed by fewer than average unique users",
          "average_discovery" : "Assets attracting an average number of unique viewers, suggesting typical interest and engagement",
          "high_discovery" : "Assets with a high number of unique viewers, indicating widespread interest and visibility"
        }
      }
    },
    "engagement": {
      "title": "Engagement",
      "sub_text": "How do end-users engage with your content?",
      "cards": {
        "attention_time": "Avg. Attention time",
        "unique_viewers": "# of unique viewers",
        "shares": "# of shares",
        "asset_views": "# of Asset Views",
        "popular_viewers": "What's popular with your viewers?",
        "top_viewers": "Who are your top known viewers?",
        "top_accounts": "Who are your top accounts?",
        "campaigns": "How are your campaigns performing?",
        "content_shared": "How are your content shared?",
        "conversation_activity": "Conversation Activity",
        "collection_activity": "Collection Activity",
        "filters": {
          "all_viewers": "All viewers",
          "known_viewers": "Known viewers",
          "anonymous_viewers": "Anonymous viewers",
          "views": "Views",
          "avg_time": "Avg Time",
          "downloads": "Downloads"
        },
        "tooltip_texts":{
          "attention_time": "The average duration of asset engagement by end users in fliteview",
          "unique_viewers": "Daily count of unique viewers who interacted with content in fliteview",
          "shares": "Daily count of shares made, offering insights into content distribution trends",
          "asset_views": "Daily count of total unique asset views",
          "popular_viewers":  "Discover which assets shared received the highest engagement, with the option to sort by Views, average time spent and downloads",
          "top_viewers": "Known users with the highest asset views in fliteview",
          "top_accounts": "Accounts with the highest cumulative asset views across users",
          "campaigns": "Top performing campaigns’ sorted based on views",
          "content_shared": "The most preferred methods for sharing content",
          "conversation_activity": "Most recent shares along with their engagement metrics",
          "collection_activity": "Collection created with the highest engagement activity"
      }
    }
    },
    "performance": {
      "title": "Performance",
      "sub_text": "How does your content perform?",
      "cards":{
        "interactions": "# of Interactions powered by content",
        "leads": "# of Leads",
        "deals": "# of Deals",
        "deal_value": "Deal value",
        "closed_deals": "# of Closed Deals",
        "closed_deal_value": "Closed Deal Value",
        "generate_leads": "Top content that generates leads",
        "content_that_closed_deals": "Top content that closed deals",
        "leads_detail": "Leads: Detail",
        "deals_detail": "Deals: Detail",
        "tooltip_texts":{
          "interactions_content": "Track the number of shares associated with deals in your CRM on a daily basis", 
          "leads": "Monitor daily lead generation activity through gated shares to assess growth and effectiveness of your content",
          "deals": "Track daily deal creation to stay informed on your team's sales progress and productivity",
          "deal_value": "View the cumulative value of created deals to assess overall revenue potential",
          "closed_deals": "Track daily count of closed deals to measure sales team performance and deal closure efficiency",
          "closed_deal_value": "View the total value of deals closed to assess revenue impact and sales performance",
          "content_generate_leads": "Identify top-performing content that drives lead generation, enabling targeted content strategies for optimal results",
          "content_closed_deals": "Discover the most impactful content that contributes to deal closures, facilitating strategic content distribution for successful sales outcomes"
      }
    }
  }
},
  
  "toast":{
    "success": "Downloaded {name} report successfully",
    "failure": {
      "title": "Oops Error!",
      "message": "Unable to process request, Please try after sometime."
    }
  }
}

